import VAutocomplete from '../../GENIO/components/GAutocomplete/GAutocomplete'

export { VAutocomplete }
export default VAutocomplete
